import {ProgressControls} from './ProgressControls';

export const holder = {instance: null as null | ProgressControls};
